// 📁 src/layouts/PublicLayout.js

import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';

export default function PublicLayout() {
  const [currency, setCurrency] = useState('USD');
  const [billingCycle, setBillingCycle] = useState('monthly');

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        scrollToId={scrollToId}
        currency={currency}
        setCurrency={setCurrency}
        billingCycle={billingCycle}
        setBillingCycle={setBillingCycle}
        showCTA={true}
        showLogin={true}
      />
      <Outlet context={{ currency, billingCycle }} />
    </div>
  );
}
